import { jsxs, jsx } from "react/jsx-runtime";
const IconArrowRightSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.433 9.683a.832.832 0 0 0-.175-.275l-4.166-4.166a.837.837 0 0 0-1.184 1.183l2.75 2.742H6.333a.833.833 0 0 0 0 1.666h6.325l-2.75 2.742a.833.833 0 0 0 0 1.183.834.834 0 0 0 1.184 0l4.166-4.166a.832.832 0 0 0 .175-.275.833.833 0 0 0 0-.634Z" })
    ]
  }
);
export {
  IconArrowRightSvg
};
